import { ILaneRateCard, TSettingsRateCardType } from '@types';

export const getRateCardIndex = ({
	rateCardSettingsTypes,
	rateCardTypes,
	id,
	isSettings,
	type,
}: {
  rateCardSettingsTypes: TSettingsRateCardType[];
  rateCardTypes: ILaneRateCard[];
  id?: string;
  isSettings: boolean;
  type?: string;
}) => {
	const rcTypeAtom = isSettings ? rateCardSettingsTypes : rateCardTypes;
	const index = rcTypeAtom.findIndex((rateCard) => {
		return (
			(id && rateCard?.item_definition?.item_id === id) ||
			(!id && rateCard.type === type)
		);
	});

	return String(index);
}